"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeMirror = void 0;
require("./styles.scss");
const _codemirror_html_1 = __importDefault(require("./_codemirror.html"));
const lodash_1 = require("lodash");
const vue_1 = __importDefault(require("vue"));
const _CodeMirror = __importStar(require("./_cm"));
const vue_property_decorator_1 = require("vue-property-decorator");
const CM = _CodeMirror.default;
const EVENTS = [
    'scroll',
    'changes',
    'beforeChange',
    'cursorActivity',
    'keyHandled',
    'inputRead',
    'electricInput',
    'beforeSelectionChange',
    'viewportChange',
    'swapDoc',
    'gutterClick',
    'gutterContextMenu',
    'focus',
    'blur',
    'refresh',
    'optionChange',
    'scrollCursorIntoView',
    'update'
];
let CodeMirror = class CodeMirror extends vue_1.default {
    cm;
    content;
    code;
    value;
    marker;
    unseenLines;
    name;
    mode;
    placeholder;
    merge;
    options;
    globalOptions;
    events;
    globalEvents;
    onOptionsChanged(newValue) {
        (0, lodash_1.each)(newValue, (v, k) => this.cm.setOption(k, v));
    }
    onMergeChanged() {
        this.$nextTick(() => this.switchMerge());
    }
    onCodeChanged(newValue) {
        this.handleCodeChanged(newValue);
    }
    onValueChanged(newValue) {
        this.handleCodeChanged(newValue);
    }
    data() {
        return {
            cm: null,
            content: '',
            wrapperClass: {
                merge: this.merge
            }
        };
    }
    mounted() {
        this.initialize();
    }
    beforeDestroy() {
        this.destroy();
    }
    initialize() {
        const opts = this.getOptions();
        if (this.merge) {
            let codemirror = CM.MergeView(this.$refs.mergeview, opts);
            this.cm = codemirror.edit;
        }
        else {
            this.cm = CM.fromTextArea(this.$refs.textarea, opts);
            this.cm.setValue(this.code || this.value || this.content || '');
        }
        const cm = this.cm, tmpEvents = {}, allEvents = []
            .concat(EVENTS, this.events, this.globalEvents)
            .filter(e => !tmpEvents[e] && (tmpEvents[e] = true))
            .forEach(event => {
            cm.on(event, (...args) => {
                this.$emit(event, ...args);
                const lowerCaseEvent = event
                    .replace(/([A-Z])/g, '-$1')
                    .toLowerCase();
                if (lowerCaseEvent !== event) {
                    this.$emit(lowerCaseEvent, ...args);
                }
            });
        });
        this.cm.on('change', (cm) => {
            this.content = cm.getValue();
            if (this.$emit) {
                this.$emit('input', this.content);
            }
        });
        this.$emit('ready', this.cm);
        this.unseenLineMarkers();
        this.refresh();
    }
    getOptions() {
        let opts = {};
        if (this.mode === 'json') {
            opts['mode'] = {
                name: 'javascript',
                json: true,
                statementIndent: 2
            };
        }
        else if (this.mode === 'css') {
            opts['mode'] = {
                name: 'css',
                statementIndent: 2
            };
        }
        else if (this.mode === 'yaml') {
            opts['mode'] = {
                name: 'yaml',
                statementIndent: 2
            };
        }
        else if (this.mode === 'html') {
            opts['mode'] = {
                name: 'htmlmixed',
                statementIndent: 2
            };
        }
        return Object.assign(opts, this.globalOptions, this.options);
    }
    refresh() {
        this.$nextTick(() => this.cm.refresh());
    }
    destroy() {
        const element = this.cm.doc.cm.getWrapperElement();
        if (element && element.remove) {
            element.remove();
        }
    }
    handleCodeChanged(newValue) {
        const value = this.cm.getValue();
        if (!newValue) {
            newValue = '';
        }
        if (newValue !== value) {
            const scrollInfo = this.cm.getScrollInfo();
            this.cm.setValue(newValue);
            this.content = newValue;
            this.cm.scrollTo(scrollInfo.left, scrollInfo.top);
        }
        this.unseenLineMarkers();
    }
    unseenLineMarkers() {
        if (this.unseenLines !== undefined && this.marker !== undefined) {
            (0, lodash_1.each)(this.unseenLines, line => {
                const info = this.cm.lineInfo(line);
                this.cm.setGutterMarker(line, 'breakpoints', info.gutterMarkers ? null : this.marker());
            });
        }
    }
    switchMerge() {
        const history = this.cm.doc.history;
        const cleanGeneration = this.cm.doc.cleanGeneration;
        this.options['value'] = this.cm.getValue();
        this.destroy();
        this.initialize();
        this.cm.doc.history = history;
        this.cm.doc.cleanGeneration = cleanGeneration;
    }
};
exports.CodeMirror = CodeMirror;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], CodeMirror.prototype, "code", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], CodeMirror.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Function)
], CodeMirror.prototype, "marker", void 0);
__decorate([
    Function(),
    __metadata("design:type", Array)
], CodeMirror.prototype, "unseenLines", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'codemirror' }),
    __metadata("design:type", String)
], CodeMirror.prototype, "name", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], CodeMirror.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' }),
    __metadata("design:type", String)
], CodeMirror.prototype, "placeholder", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], CodeMirror.prototype, "merge", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: () => ({}) }),
    __metadata("design:type", Object)
], CodeMirror.prototype, "options", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: () => ({}) }),
    __metadata("design:type", Object)
], CodeMirror.prototype, "globalOptions", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: () => [] }),
    __metadata("design:type", Array)
], CodeMirror.prototype, "events", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: () => [] }),
    __metadata("design:type", Array)
], CodeMirror.prototype, "globalEvents", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('options', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CodeMirror.prototype, "onOptionsChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('merge'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CodeMirror.prototype, "onMergeChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('code'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CodeMirror.prototype, "onCodeChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CodeMirror.prototype, "onValueChanged", null);
exports.CodeMirror = CodeMirror = __decorate([
    (0, vue_property_decorator_1.Component)({ template: _codemirror_html_1.default })
], CodeMirror);
//# sourceMappingURL=_codemirror.js.map